import React from "react";
import {
  Add_Calender,
  BackArrowIcon,
  ChevronLeft,
  ChevronRight,
  Clock,
  MapIcon,
  Normal_Back_Arrow,
  Normal_Front_Arrow,
  Pin_Location,
} from "../../utils/SvgComponents";
import CustomButton from "../common/button/Button";

export default function OpenPlaceButton({link, customClass, isMobile}) {
  console.log("custom link : ", link);

  // ---------- Helpers ----------
  const isIOS = () =>
    /iPad|iPhone|iPod/.test(navigator.userAgent) ||
    (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);

  const isAndroid = () => /Android/.test(navigator.userAgent);

  const normalizeUrl = (u) => {
    const s = (u || "").trim();
    if (!s) return "";
    if (/^https?:\/\//i.test(s)) return s;
    return "https://" + s;
  };

  const parseCoordsToken = (token) => {
    const s = token.trim();
    const m = s.match(
      /^\s*(-?\d+(?:\.\d+)?)\s*,\s*(-?\d+(?:\.\d+)?)(?:\s*,\s*(\d{1,2})z?)?\s*$/i
    );
    if (!m) return null;
    const lat = parseFloat(m[1]);
    const lng = parseFloat(m[2]);
    const zoom = m[3]
      ? Math.max(0, Math.min(21, parseInt(m[3], 10)))
      : null;
    if (Number.isNaN(lat) || Number.isNaN(lng)) return null;
    return { lat, lng, zoom };
  };

  const linksFromCoords = ({ lat, lng, zoom }) => {
    const zParam = zoom != null ? `&z=${zoom}` : "";
    const zGeo = zoom != null ? `?z=${zoom}` : "";
    return {
      apple: `https://maps.apple.com/?ll=${lat},${lng}&q=Pinned%20Location`,
      googleWeb: `https://www.google.com/maps?q=${lat},${lng}${zParam}`,
      androidGeo: `geo:${lat},${lng}${zGeo}`,
    };
  };

  const classifyLinks = (input) => {
    if (typeof input !== "string") {
      console.error("classifyLinks: Expected a string but got", input);
      return { coords: null, google: "", apple: "", any: [] };
    }

    const parts = input.split(";").map((s) => s.trim()).filter(Boolean);

    if (parts.length === 1) {
      const c = parseCoordsToken(parts[0]);
      if (c) return { coords: c, google: "", apple: "", any: [] };
    }

    const out = { coords: null, google: "", apple: "", any: [] };
    for (const raw of parts) {
      if (!out.coords) {
        const c = parseCoordsToken(raw);
        if (c) {
          out.coords = c;
          continue;
        }
      }
      const url = normalizeUrl(raw);
      try {
        const host = new URL(url).hostname.toLowerCase();
        const isGoogle =
          host.includes("maps.app.goo.gl") ||
          host.includes("google.com") ||
          host.endsWith(".google") ||
          host.includes("goo.gl");
        const isApple = host.includes("maps.apple.com") || host === "maps.apple";
        if (isGoogle && !out.google) out.google = url;
        else if (isApple && !out.apple) out.apple = url;
        else out.any.push(url);
      } catch (_) {}
    }
    return out;
  };

  const pickBestLink = (links) => {
    if (links.coords) {
      const built = linksFromCoords(links.coords);
      if (isIOS()) return built.apple || links.apple || links.google || built.googleWeb;
      if (isAndroid()) return built.androidGeo || links.google || built.googleWeb || links.apple;
      return built.googleWeb || links.google || links.apple || links.any[0] || "";
    }
    if (isIOS()) return links.apple || links.google || links.any[0] || "";
    if (isAndroid()) return links.google || links.apple || links.any[0] || "";
    return links.google || links.apple || links.any[0] || "";
  };

  const openPlace = (linkString) => {
    console.log("links : ", linkString);

    const links = classifyLinks(linkString);
    const target = pickBestLink(links);

    if (!target) {
      alert("No valid map link or coordinates found.");
      return;
    }

    // Open in new tab instead of redirecting in same page
    window.open(target, "_blank");
  };

  return (
    isMobile ?  
      <CustomButton
              clicked={() => openPlace(
                    link
                )}
                   className="buttonripple"
              borderRadius={"9999px"}
              bgColor={"black"}
              paddingX={"20px"}
              paddingY={"11px"}
              minWidth={"0"}
              animationDuration="0s"
            >
              <div className="flex gap-2">
                <MapIcon fill="white" width="20" />
                <div className="text-white">Open Map</div>
              </div>
            </CustomButton>
    
    :
        <button
            onClick={() =>
                openPlace(
                    link
                )
            }
            className={customClass}
        >
            <div className="p-[5px]">
              <MapIcon width="22" fill="white" />
            </div>
            
            <span className="p-1 py-2"> View Directions</span>

      </button>
        
  );
}
